import { Controller } from "@hotwired/stimulus";

// Auto-submits the form when any field changes.
// Attach via data-controller="remote-form" data-action="change->remote-form#update"
export default class extends Controller {
  update() {
    this.element.requestSubmit();
  }
}
